// extracted by mini-css-extract-plugin
module.exports = {"cadenceBadge":"CadenceBadge_cadenceBadge___I6AK"};